import React, { useMemo, useState } from 'react'
import { createRoot } from 'react-dom/client'

function normalizeRaw(value) {
  if (!value) return ''
  const cleaned = String(value).replace(/[^0-9.]/g, '')
  const [whole, ...rest] = cleaned.split('.')
  if (!rest.length) return whole
  return `${whole}.${rest.join('')}`
}

function formatGrouped(raw) {
  if (raw === '') return ''
  const [whole = '', decimal] = raw.split('.')
  const number = Number(whole || 0)
  const grouped = new Intl.NumberFormat('en-PH').format(number)
  if (decimal !== undefined) return `PHP ${grouped}.${decimal}`
  return `PHP ${grouped}`
}

export function formatMoney(value) {
  const amount = Number(value || 0)
  if (Number.isNaN(amount)) return 'PHP 0'
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    currencyDisplay: 'code',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function MoneyInput({ value, onChange, inputClassName, placeholder }) {
  const rawValue = value ?? ''
  const displayValue = useMemo(() => formatGrouped(normalizeRaw(rawValue)), [rawValue])

  function handleChange(event) {
    const nextRaw = normalizeRaw(event.target.value)
    if (onChange) onChange(nextRaw)
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      className={inputClassName}
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
    />
  )
}

function MountedMoneyInput({ name, initialValue, inputClassName, placeholder }) {
  const [rawValue, setRawValue] = useState(normalizeRaw(initialValue))

  return (
    <div>
      <input type="hidden" name={name} value={rawValue} />
      <MoneyInput
        value={rawValue}
        onChange={setRawValue}
        inputClassName={inputClassName}
        placeholder={placeholder}
      />
    </div>
  )
}

export function mountMoneyInputs() {
  const nodes = document.querySelectorAll('[data-money-input]')
  nodes.forEach((node) => {
    const name = node.dataset.fieldName
    if (!name) return
    const initialValue = node.dataset.initialValue || ''
    const inputClassName = node.dataset.inputClass || 'form-control'
    const placeholder = node.dataset.placeholder
    const root = createRoot(node)
    root.render(
      <MountedMoneyInput
        name={name}
        initialValue={initialValue}
        inputClassName={inputClassName}
        placeholder={placeholder}
      />
    )
  })
}
